function smoothScroll() {
    let x = document.querySelectorAll('a[href*="#"]');
    for (let i = 0; i < x.length; i++) {
      x[i].addEventListener("click", function(e) {
        // Only handle on-page anchors
        if (
          this.hash &&
          document.location.pathname === this.pathname &&
          document.location.hostname === this.hostname
        ) {
          e.preventDefault();
          let target = document.querySelector(this.hash);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    }
  }
  smoothScroll();